import { CustomFormat } from "./CustomFormat";
import { RoundRobinFormat } from "./RoundRobinFormat";
import { SingleEliminationFormat } from "./SingleEliminationFormat";
import { SwissFormat } from "./SwissFormat";
import { SwissWithDivisionsFormat } from "./SwissWithDivisionsFormat";
import type { TournamentFormat } from "./TournamentFormat";

// Core types and interfaces
export type { TournamentFormat } from "./TournamentFormat";
export { TournamentStateConverter } from "./TournamentStateConverter";
export { TimeEstimationService } from "./TimeEstimationService";
export * from "./types";

export const formats = {
  SingleElimination: new SingleEliminationFormat(),
  RoundRobin: new RoundRobinFormat(),
  Swiss: new SwissFormat(),
  SwissWithDivisions: new SwissWithDivisionsFormat(),
  Custom: new CustomFormat(),
} as const;
export type FormatName = keyof typeof formats;

export function getFormat(format: FormatName): TournamentFormat<any> {
  const instance = formats[format];

  if (!format) {
    throw new Error(`Unknown format: ${format}`);
  }

  return instance;
}
